// @flow
import { commonPaths } from "buba-components";

export default {
  // TODO(v1-removal): V1 bank paths below are kept only for redirect routes. Delete after grace period along with all V1 redirect routes in routes.js.
  bankInquiriesList: "/bankanfragen",
  bankInquiryDashboard: (id: ":id" | number) => `/bankanfragen/${id}/dashboard`,
  bankInquiryDetails: (id: ":id" | number) => `/bankanfragen/${id}/detailansicht`,
  bankInquiryDocuments: (id: ":id" | number) => `/bankanfragen/${id}/unterlagenaustausch`,
  bankInquiriesListNew: "/bankanfragen-neu",
  bankInquiryDashboardNew: (id: ":id" | number) => `/bankanfragen-neu/${id}/dashboard`,
  bankInquiryDetailsNew: (id: ":id" | number) => `/bankanfragen-neu/${id}/detailansicht`,
  bankInquiryDocumentsNew: (id: ":id" | number) => `/bankanfragen-neu/${id}/unterlagenaustausch`,
  bankInquiryApplication: (id: ":id" | number) => `/bankanfragen-neu/${id}/antrag`,
  customerInquiriesList: "/kundenanfragen",
  customerInquiryDashboard: (id: ":id" | number) => `/kundenanfragen/${id}/dashboard`,
  customerInquiryDetails: (id: ":id" | number) => `/kundenanfragen/${id}/detailansicht`,
  customerInquiryDocuments: (id: ":id" | number) => `/kundenanfragen/${id}/unterlagenaustausch`,
  userData: "/meineDaten",
  resetPassword: "/vergessenPasswort",
  refreshPassword: "/abgelaufenPasswort",
  newPassword: (token: ":token" | string) => `/neuesPasswort/${token}`,
  activateUser: (token: ":token" | string) => `/aktivieren/${token}`,
  login: "/anmelden",
  logout: "/abmelden",
  ssoCallback: "/sso",
  ...commonPaths
};
